import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "profile",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().userSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),

  endpoints: (builder) => ({
    getUserApi : builder.query({
      query : () => ({
        url : "" ,
        method: "GET"
      })
    }) ,
    addAddressApi: builder.mutation({
      query: (fields) => ({
        url: "/address",
        method: "POST",
        body: JSON.stringify(fields),
      }),
      
    }),
    removeAddressApi: builder.mutation({
      query: (adCode)=>({
        url : `/address?address_code=${adCode}`,
        method : "DELETE" ,
      })
    }),
    getFavoriteApi: builder.query({
      query: ()=>({
        url : `/favorite_product`,
        method : "GET" ,
      })
    }),
    patchFavoriteApi: builder.mutation({
      query: (adCode)=>({
        url : `/favorite_product?product_code=${adCode}`,
        method : "PATCH" ,
      })
    })
  }),
});
export const {useAddAddressApiMutation , useRemoveAddressApiMutation , useGetUserApiQuery , usePatchFavoriteApiMutation , useGetFavoriteApiQuery} = userApi